import React, { memo } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

import { tableSectionStyles, wrapperStyles } from './Incomes.styles';
import QualifiedIncomesTable from './QualifiedIncomesTable';
import ValidationRulesTable from './ValidationRulesTable';

const defaultObject = {};

const Incomes = ({ isLoading, incomes = defaultObject }) => {
  const { validationRules, qualifiedIncomes } = incomes;

  return (
    <Box data-testid={UnderwritingTestIds.UW_REPORTS_INCOMES_SECTION} sx={wrapperStyles}>
      <Typography data-truncated className="truncate" variant="bold16">
        Incomes
      </Typography>

      <Divider />

      <Box sx={tableSectionStyles}>
        <Typography data-truncated className="truncate" variant="bold16">
          Validation Rules Table
        </Typography>

        <ValidationRulesTable isLoading={isLoading} validationRules={validationRules} />
      </Box>

      <Box sx={tableSectionStyles}>
        <Typography data-truncated className="truncate" variant="bold16">
          Qualified Incomes Table
        </Typography>

        <QualifiedIncomesTable isLoading={isLoading} qualifiedIncomes={qualifiedIncomes} />
      </Box>
    </Box>
  );
};

Incomes.propTypes = {
  ...WithLoadingPropTypes,
  incomes: PropTypes.shape({
    validationRules: PropTypes.array,
    qualifiedIncomes: PropTypes.array,
  }),
};

export default memo(Incomes);
